import { ListProps } from 'react-admin';
import { CandidateFilter } from '@/pages/Candidate/actions';
import { MainListStyled } from '@/styles/overrides';
import Datagrid from './Datagrid';

const CandidateList = (props: ListProps) => {
  return (
    <MainListStyled
      filters={<CandidateFilter />}
      sort={{ field: 'date_initiated', order: 'DESC' }}
      storeKey={false}
      title="Candidates"
      {...props}
    >
      <Datagrid />
    </MainListStyled>
  );
};

export default CandidateList;
